import { DialogContent, DialogTitle } from "@mui/material";
import { Form } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNomenclatures, getProviderServicesByNomenclature } from "../../../../actions/providedServices";
import { StyledDialog } from "../../../styled/dialog";
import CustomDialog from "../../dialog/customDialog";
import FormikActions from "../../formik/formikActions";
import FormikForm from "../../formik/formikForm";
import ProviderServicePracticeForm from "./providerServicePracticeForm";
import { providerServicePracticeFormValidationSchema } from "./providerServicePracticeValidations";

const initialValues = {
  id: null,
  art: "",
  prestador: "",
  subnomenclador: "",
  prestacion: "",
  nombre: "",
  descripcion: "",
  habilitada: false,
}

const ProviderServicePracticeFormContainer = ({ open, handleClose, handleSubmit, serviceToEdit, loading }) => {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.providers.listProviders);
  const art = useSelector((state) => state.arts);
  const [loadingInternal, setLoadingInternal] = useState(true);
  const [firstLoading, setFirstLoading] = useState(true);

  const [formInitialValues, setFormInitialValues] = useState(initialValues);

  useEffect(() => {
    if (serviceToEdit) {
      if (serviceToEdit.artId) {
        Promise.all([dispatch(getNomenclatures(serviceToEdit.artId)),
        dispatch(getProviderServicesByNomenclature(serviceToEdit.artId, serviceToEdit.subnomenclatura))]).finally(() => {
          setFirstLoading(false);
        })

      }
      setFormInitialValues({
        id: serviceToEdit.id,
        art: serviceToEdit.artId,
        prestador: serviceToEdit.providerId,
        subnomenclador: serviceToEdit.subnomenclatura,
        prestacion: serviceToEdit.prestacion,
        nombre: serviceToEdit.nombrePrestacion,
        descripcion: serviceToEdit.descripcionPrestacion,
        habilitada: serviceToEdit.habilitada,
      })
    } else {
      setFormInitialValues(initialValues);
      setFirstLoading(false);
    }
  }, [serviceToEdit])

  useEffect(() => {
    if (!open) {
      setLoadingInternal(true);
      setFirstLoading(true);
    } else {
      setLoadingInternal(firstLoading || providers.isFetching || art.isFetching);
    }
  }, [firstLoading, art, providers, open])

  return (
    <>
      <CustomDialog
        open={open}
        onClose={handleClose}
        scroll="paper"
      >
        <DialogTitle>
          {serviceToEdit ? "Editar Prestación" : "Agregar Prestación"}
        </DialogTitle>
        <FormikForm
          initialValues={formInitialValues}
          enableReinitialize
          validationSchema={providerServicePracticeFormValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <DialogContent >
                <StyledDialog.Container>
                  <ProviderServicePracticeForm loading={loadingInternal || loading} editing={!!serviceToEdit} />
                </StyledDialog.Container>
              </DialogContent>
              <StyledDialog.Actions>
                <FormikActions
                  handleCancel={handleClose}
                  submitText="Aceptar"
                  disabled={loadingInternal || loading}
                />
              </StyledDialog.Actions>
            </Form>
          )}
        </FormikForm>
      </CustomDialog>
    </>
  )
}

export default ProviderServicePracticeFormContainer;